import * as actionTypes from "./actionTypes";
import * as types from "./types";

const initPatternsState: types.IPatternsState = {
  pending: false,
  patterns: {},
  error: null,
};

export const PatternsReducer = (
  state = initPatternsState,
  action: types.PatternsActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_PATTERNS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_PATTERNS_SUCCESS:
      return {
        ...state,
        pending: false,
        patterns: state.patterns
          ? {
            ...state.patterns,
            [action.payload.layerType]: action.payload.patterns,
          }
          : { [action.payload.layerType]: action.payload.patterns },
        error: null,
      };
    case actionTypes.FETCH_PATTERNS_FAIL:
      return {
        ...state,
        pending: false,
        patterns: state.patterns ? { ...state.patterns } : {},
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

//custom
const initCustExtState: types.ICustomExtState = {
  pending: false,
  extractor: null,
  error: null,
};

export const CustExtReducer = (
  state = initCustExtState,
  action: types.PostCustomExtractorActions
) => {
  switch (action.type) {
    case actionTypes.POST_CUSTOMEXT_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_CUSTOMEXT_SUCCESS:
      return {
        ...state,
        pending: false,
        extractor: action.payload.customExtStatus,
        error: null,
      };
    case actionTypes.POST_CUSTOMEXT_FAILURE:
      return {
        ...state,
        pending: false,
        extractor: [],
        error: action.payload.error,
      };
      case actionTypes.POST_CUSTOMEXT_RESET:
        return {
          ...state,
          pending: false,
          extractor: null,
          error: null,
        };
    default:
      return {
        ...state,
      };
  }
};

//DB Extractor
const initDBExtState: types.IDBExtState = {
  pending: false,
  extractor: null,
  error: null,
};

export const DBExtReducer = (state = initDBExtState, action: types.PostMetaDataDBExtActions) => {
  switch (action.type) {
    case actionTypes.POST_DBEXT_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_DBEXT_SUCCESS:
      return {
        ...state,
        pending: false,
        extractor: action.payload.dbExtStatus,
        error: null,
      };
    case actionTypes.POST_DBEXT_FAILURE:
      return {
        ...state,
        pending: false,
        extractor: [],
        error: action.payload.error,
      };
    case actionTypes.POST_DBEXT_RESET:
      return {
        ...state,
        pending: false,
        extractor: null,
        error: null,
      };
    default:
      return {
        ...state,
      };
  }
};


const initExtractorListState: types.ExtractorListState = {
  pending: false,
  extractors: {} as types.IDataExtractorList,
  error: null,
};

export const ExtractorListReducer = (state = initExtractorListState, action: types.ExtractorListActions) => {
  switch (action.type) {
    case actionTypes.FETCH_EXTRACTOR_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_EXTRACTOR_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        extractors: action.payload.extractors,
        error: null,
      };
    case actionTypes.FETCH_EXTRACTOR_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        extractors: {} as types.IDataExtractorList,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

const initExtractorDetailState: types.IExtractorDetailState = {
  pending: false,
  extractorDetail: null,
  error: null,
};

export const ExtractorDetailReducer = (
  state = initExtractorDetailState,
  action: types.ExtractorDetailActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_EXTRACTOR_DETAIL_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_EXTRACTOR_DETAIL_SUCCESS:
      return {
        ...state,
        pending: false,
        extractorDetail: action.payload.extractorDetail,
        error: null,
      }
    case actionTypes.FETCH_EXTRACTOR_DETAIL_FAILURE:
      return {
        ...state,
        pending: false,
        extractorDetail: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

// DELETE Extractor

const initDeleteExtractorState: types.IDeleteExtractorState = {
  pending: false,
  deleteStatus: null,
  error: null,
};

export const DeleteExtractorReducer = (state = initDeleteExtractorState, action: types.DeleteExtractorActions) => {
  switch (action.type) {
    case actionTypes.DELETE_EXTRACTOR_REQUEST:
      return {
        ...state,
        deleteStatus: null,
        pending: true,
      };
    case actionTypes.DELETE_EXTRACTOR_SUCCESS:
      return {
        ...state,
        pending: false,
        deleteStatus: action.payload.deleteStatus,
        error: null,
      };
    case actionTypes.DELETE_EXTRACTOR_FAILURE:
      return {
        ...state,
        pending: false,
        deleteStatus: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

// PUT EXTRACTOR
const initialStatePutExtractor: types.IPutExtractorState = {
  pending: false,
  extractor: null,
  error: null,
};

export const PutExtractorReducer = (state = initialStatePutExtractor, action: types.PutExtractorActions) => {
  switch (action.type) {

    case actionTypes.PUT_EXTRACTOR_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.PUT_EXTRACTOR_SUCCESS:
      return {
        ...state,
        pending: false,
        extractor: action.payload.extractor,
        error: null,
      };
    case actionTypes.PUT_EXTRACTOR_SKIP:
      return {
        ...state,
        pending: false,
        extractor: {extractor: true},
        error: null,
      };
    case actionTypes.PUT_EXTRACTOR_FAILURE:
      return {
        ...state,
        pending: false,
        extractor: null,
        error: action.payload.error,
      };
      case actionTypes.PUT_EXTRACTOR_RESET:
        return {
          ...state,
          pending: false,
          extractor: null,
          error: null,
        };
    default:
      return {
        ...state,
      };
  }

};

// Extractor Status
const initExtractorStatusState: types.IExtractorStatusState = {
  pending: false,
  extractorStatus: null,
  error: null,
};

export const ExtractorStatusReducer = (
  state = initExtractorStatusState,
  action: types.ExtractorStatusActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_EXTRACTOR_STATUS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.FETCH_EXTRACTOR_STATUS_SUCCESS:
      return {
        ...state,
        pending: false,
        extractorStatus: action.payload.extractorStatus,
        error: null,
      }
    case actionTypes.FETCH_EXTRACTOR_STATUS_FAILURE:
      return {
        ...state,
        pending: false,
        extractorStatus: null,
        error: action.payload.error,
      };
      case actionTypes.FETCH_EXTRACTOR_STATUS_RESET:
        return {
          ...state,
          pending: false,
          extractorStatus: null,
          error: null,
        };
    default:
      return {
        ...state,
      };
  }
};

//Put Schema Extractor
const initialStatePostSchemaExt: types.IPostSchemaExtState = {
  pending: false,
  extractor: null,
  error: null,
};

export const PostSchemaExtReducer = (state = initialStatePostSchemaExt, action: types.PostSchemaExtActions) => {
  switch (action.type) {

    case actionTypes.POST_EXTRACTORSCHEMA_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_EXTRACTORSCHEMA_SUCCESS:
      return {
        ...state,
        pending: false,
        extractor: action.payload.extractor,
        error: null,
      };
    case actionTypes.POST_EXTRACTORSCHEMA_FAILURE:
      return {
        ...state,
        pending: false,
        extractor: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }

};

//Post retry Schema Update
const initialStatePostRetrySchema: types.IPostRetrySchemaUpdateState = {
  pending: false,
  extractor: null,
  error: null,
};

export const PostRetrySchemaUpdateReducer = (state = initialStatePostRetrySchema, action: types.PostRetrySchemaUpdateActions) => {
  switch (action.type) {

    case actionTypes.POST_RETRYSCHEMAUPDATE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_RETRYSCHEMAUPDATE_SUCCESS:
      return {
        ...state,
        pending: false,
        extractor: action.payload.extractor,
        error: null,
      };
    case actionTypes.POST_RETRYSCHEMAUPDATE_FAILURE:
      return {
        ...state,
        pending: false,
        extractor: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};